import { Breadcrumbs, Link, Typography } from "@mui/material";

// Crumb is the little the trail needs about a task the panel walked through
export type Crumb = {
    id: number;
    title: string;
};

// TrailStep is one step of the trail. The step with no onClick is where the panel is
// now, so it's drawn as text rather than as a way back.
export type TrailStep = {
    title: string;
    onClick?: () => void;
};

// TaskCrumbs shows how the panel got to what it's showing, outermost step first. A
// lone step is what the panel already has a title for, so the trail stays hidden
// until there's somewhere to go back to.
export function TaskCrumbs(props: {
    value: TrailStep[];
}) {
    if (props.value.length < 2) return null;

    return (
        <Breadcrumbs
            maxItems={3}
            itemsBeforeCollapse={1}
            itemsAfterCollapse={1}
            separator="›"
            // the trail stays on one line: a step that doesn't fit is cut short, and the
            // step the panel is on gets whatever room the others leave
            sx={{
                flex: 1,
                minWidth: 0,
                fontSize: "0.75rem",
                "& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
                "& .MuiBreadcrumbs-li": { minWidth: 0, flexShrink: 1 },
                "& .MuiBreadcrumbs-li:not(:last-of-type)": { maxWidth: 160 },
                "& .MuiBreadcrumbs-separator": { flexShrink: 0 },
            }}
        >
            {props.value.map((step, index) => step.onClick ? (
                <Link
                    key={index}
                    component="button"
                    type="button"
                    variant="caption"
                    underline="hover"
                    color="text.secondary"
                    noWrap
                    title={step.title}
                    onClick={step.onClick}
                    sx={{ display: "block", maxWidth: "100%" }}
                >
                    {step.title}
                </Link>
            ) : (
                <Typography key={index} variant="caption" color="text.primary" noWrap
                            component="div" title={step.title}>
                    {step.title}
                </Typography>
            ))}
        </Breadcrumbs>
    );
}
